import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import Select from 'react-select';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
    handleInputChange,
    submitStockTransfer,
    searchSubmit,
} from '../../../redux/actions/stock_transfer/stock_transfer.actions';
import { ToastDanger } from '../../../Services/_toast.service';
import ItemModal from './itemModal';

function MultiTransferModal({
    stock_transfer,
    show,
    onHide,
    submitStockTransfer,
    handleInputChange,
    searchSubmit,
}) {
    const [isTransfering, setIsTransfering] = useState(false);
    const [transferType, setTransferType] = useState(null); // 'in' | 'out' | null

    // Reset every time the modal opens
    useEffect(() => {
        if (show) {
            setTransferType(null);
            setIsTransfering(false);
        }
    }, [show]);

    const handleSubmitTransfer = async () => {
        if (!remarks || !remarks.trim()) {
            return ToastDanger('Remarks is required');
        }
        setIsTransfering(true);
        try {
            await submitStockTransfer(transferType);
        } catch (error) {
            console.error('Error processing transfer:', error);
        } finally {
            setIsTransfering(false);
        }
    };

    const { transfer_item, remarks } = stock_transfer;
    const isScanning = stock_transfer.loading === 'transfer-search';

    if (!show) return null;

    const removeScannedItem = (index) => {
        const updatedItems = transfer_item.filter((_, i) => i !== index);
        handleInputChange({
            target: { name: 'transfer_item', value: updatedItems },
        });
    };

    const updateItemQty = (index, value) => {
        const updatedItems = transfer_item.map((item, i) =>
            i === index ? { ...item, qty: value } : item
        );
        handleInputChange({
            target: { name: 'transfer_item', value: updatedItems },
        });
    };

    const updateItemUnit = (index, selected) => {
        const updatedItems = transfer_item.map((item, i) =>
            i === index
                ? {
                      ...item,
                      selected_product_unit_id: selected.value,
                      selected_product_unit_name: selected.label,
                      selected_conversion_to_base:
                          selected.conversion_to_base || 1,
                  }
                : item
        );
        handleInputChange({
            target: { name: 'transfer_item', value: updatedItems },
        });
    };

    return (
        <>
        <style>{`.modal-transfer-mid { max-width: 980px; }`}</style>
        <Modal show={show} onHide={onHide} dialogClassName="modal-transfer-mid" centered>
            <Modal.Header closeButton>
                <Modal.Title>
                    Process Multi Transfer{' '}
                    {transferType && (
                        <span
                            className={`badge badge-${
                                transferType === 'in' ? 'success' : 'danger'
                            } ml-2`}
                            style={{
                                fontSize: '0.75rem',
                                verticalAlign: 'middle',
                            }}
                        >
                            {transferType.toUpperCase()}
                        </span>
                    )}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                {transferType === null ? (
                    /* ── Transfer Type Selection ── */
                    <div className="text-center py-5">
                        <p
                            className="mb-4"
                            style={{ fontSize: '1.1rem', fontWeight: 600 }}
                        >
                            Choose Transfer Type
                        </p>
                        <div className="d-flex justify-content-center">
                            <button
                                className="btn btn-success btn-lg mr-4"
                                style={{ minWidth: '120px' }}
                                onClick={() => setTransferType('in')}
                            >
                                <i className="ft ft-arrow-down mr-1"></i> IN
                            </button>
                            <button
                                className="btn btn-danger btn-lg"
                                style={{ minWidth: '120px' }}
                                onClick={() => setTransferType('out')}
                            >
                                <i className="ft ft-arrow-up mr-1"></i> OUT
                            </button>
                        </div>
                    </div>
                ) : (
                    /* ── Scan UI ── */
                    <div className="col-12 mb-2 pr-2">
                        <div className="row">
                            {/* Search Bar */}
                            <div className="row mb-2 w-100">
                                <label className="col-md-2 col-sm-12 pl-0 text-right align-self-center">
                                    SKU/Barcode:
                                </label>
                                <div className="col-md-8 col-10 px-0">
                                    <form
                                        onSubmit={(e) =>
                                            searchSubmit(e, 'btn', transferType)
                                        }
                                    >
                                        <div className="input-group mb-0">
                                            <input
                                                type="text"
                                                id="search"
                                                value={stock_transfer.search}
                                                onChange={handleInputChange}
                                                name="search"
                                                className="form-control f-regular"
                                                placeholder="Scan or type SKU / Barcode"
                                                required
                                                disabled={
                                                    isScanning || isTransfering
                                                }
                                                autoFocus
                                            />
                                            <div className="input-group-append">
                                                <button
                                                    className="btn btn-primary btn-z-index"
                                                    type="submit"
                                                    disabled={
                                                        isScanning ||
                                                        isTransfering
                                                    }
                                                >
                                                    {isScanning ? (
                                                        <span
                                                            className="spinner-border spinner-border-sm"
                                                            role="status"
                                                            aria-hidden="true"
                                                        ></span>
                                                    ) : (
                                                        <i className="ft ft-search"></i>
                                                    )}
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>

                            {/* Items Table */}
                            {transfer_item.length > 0 ? (
                                <div className="col-12 p-0">
                                    <div className="table-responsive">
                                        <table className="table table-hover table-striped table-bordered f-regular">
                                            <thead>
                                                <tr>
                                                    <th
                                                        className="text-center"
                                                        style={{
                                                            width: '60px',
                                                        }}
                                                    >
                                                        Image
                                                    </th>
                                                    <th className="text-left td-16m">
                                                        SKU
                                                    </th>
                                                    <th className="text-left">
                                                        Product
                                                    </th>
                                                    <th
                                                        className="text-center"
                                                        style={{
                                                            minWidth: '90px',
                                                        }}
                                                    >
                                                        Unit
                                                    </th>
                                                    <th
                                                        className="text-center mw-6m"
                                                        style={{
                                                            minWidth: '90px',
                                                        }}
                                                    >
                                                        Qty
                                                    </th>
                                                    <th
                                                        className="text-center"
                                                        style={{
                                                            width: '60px',
                                                        }}
                                                    >
                                                        &nbsp;
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {transfer_item.map(
                                                    (item, index) => (
                                                        <tr key={index}>
                                                            {/* Image */}
                                                            <td className="text-center align-middle">
                                                                <img
                                                                    src={
                                                                        item.product_image
                                                                    }
                                                                    className="img-thumbnail"
                                                                    style={{
                                                                        width: '50px',
                                                                        height: '50px',
                                                                        objectFit:
                                                                            'cover',
                                                                    }}
                                                                    alt={
                                                                        item.product_name
                                                                    }
                                                                />
                                                            </td>

                                                            {/* SKU */}
                                                            <td className="table-data__sku align-middle">
                                                                {item.sku
                                                                    ? item.sku
                                                                          .match(
                                                                              /.{1,12}/g
                                                                          )
                                                                          .map(
                                                                              (
                                                                                  chunk,
                                                                                  i
                                                                              ) => (
                                                                                  <span
                                                                                      key={
                                                                                          i
                                                                                      }
                                                                                  >
                                                                                      {
                                                                                          chunk
                                                                                      }
                                                                                      <br />
                                                                                  </span>
                                                                              )
                                                                          )
                                                                    : '—'}
                                                            </td>

                                                            {/* Product */}
                                                            <td className="min-wdth-300 max-wdth-300 align-middle">
                                                                <div>
                                                                    <Link
                                                                        className="txt-underline text-dark font-weight-bold"
                                                                        to={`/inventory/view/${item._id}`}
                                                                        target="_blank"
                                                                    >
                                                                        {
                                                                            item.product_name
                                                                        }
                                                                    </Link>
                                                                </div>
                                                                {item.description && (
                                                                    <div className="f-12 text-dark">
                                                                        {
                                                                            item.description
                                                                        }
                                                                    </div>
                                                                )}
                                                                {item.brand_name && (
                                                                    <div className="f-12 text-dark">
                                                                        <Link
                                                                            className="txt-underline"
                                                                            to={`/inventory/products/brands/edit/${item.brand_id}`}
                                                                        >
                                                                            {
                                                                                item.brand_name
                                                                            }
                                                                        </Link>
                                                                    </div>
                                                                )}
                                                                {item.barcode && (
                                                                    <div className="f-12 text-dark">
                                                                        {
                                                                            item.barcode
                                                                        }
                                                                    </div>
                                                                )}
                                                            </td>

                                                            {/* Unit */}
                                                            <td className="text-center align-middle">
                                                                {Array.isArray(
                                                                    item.product_units
                                                                ) &&
                                                                item
                                                                    .product_units
                                                                    .length >
                                                                    1 ? (
                                                                    <Select
                                                                        value={{
                                                                            label:
                                                                                item.selected_product_unit_name ||
                                                                                item.product_unit_name,
                                                                            value:
                                                                                item.selected_product_unit_id ||
                                                                                item.product_unit_id,
                                                                        }}
                                                                        onChange={(
                                                                            selected
                                                                        ) =>
                                                                            updateItemUnit(
                                                                                index,
                                                                                selected
                                                                            )
                                                                        }
                                                                        options={item.product_units.map(
                                                                            (
                                                                                unit
                                                                            ) => ({
                                                                                label: unit.name,
                                                                                value: unit.product_unit_id,
                                                                                ...unit,
                                                                            })
                                                                        )}
                                                                        classNamePrefix="unit-select"
                                                                        menuPortalTarget={
                                                                            document.body
                                                                        }
                                                                        menuPosition="fixed"
                                                                        styles={{
                                                                            menuPortal:
                                                                                (
                                                                                    base
                                                                                ) => ({
                                                                                    ...base,
                                                                                    zIndex: 9999,
                                                                                }),
                                                                        }}
                                                                        isSearchable={
                                                                            false
                                                                        }
                                                                        isDisabled={
                                                                            isTransfering
                                                                        }
                                                                    />
                                                                ) : (
                                                                    <>
                                                                        {
                                                                            item.product_unit_name
                                                                        }
                                                                    </>
                                                                )}
                                                            </td>

                                                            {/* Qty — editable */}
                                                            <td className="text-center align-middle">
                                                                <input
                                                                    type="text"
                                                                    className="form-control text-center"
                                                                    value={
                                                                        item.qty
                                                                    }
                                                                    onChange={(
                                                                        e
                                                                    ) =>
                                                                        updateItemQty(
                                                                            index,
                                                                            e
                                                                                .target
                                                                                .value
                                                                        )
                                                                    }
                                                                    min={0}
                                                                    disabled={
                                                                        isTransfering
                                                                    }
                                                                />
                                                                {item.selected_conversion_to_base > 1 && (
                                                                    <small className="text-muted d-block mt-1">
                                                                        {item.selected_conversion_to_base} {item.product_unit_name} / {item.selected_product_unit_name}
                                                                    </small>
                                                                )}
                                                                {item.selected_conversion_to_base > 1 && parseFloat(item.qty) > 0 && (
                                                                    <small className="text-primary d-block">
                                                                        = {parseFloat(item.qty) * item.selected_conversion_to_base} {item.product_unit_name}
                                                                    </small>
                                                                )}
                                                            </td>

                                                            {/* Remove */}
                                                            <td className="text-center align-middle">
                                                                <button
                                                                    className="btn btn-danger btn-sm"
                                                                    onClick={() =>
                                                                        removeScannedItem(
                                                                            index
                                                                        )
                                                                    }
                                                                    disabled={
                                                                        isTransfering
                                                                    }
                                                                >
                                                                    <i className="ft ft-trash text-white"></i>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    )
                                                )}
                                            </tbody>
                                        </table>
                                    </div>

                                    {/* Remarks */}
                                    <div className="w-100 mt-2">
                                        <b>Remarks:</b>
                                        <textarea
                                            rows="2"
                                            placeholder="Remarks"
                                            name="remarks"
                                            value={remarks}
                                            onChange={handleInputChange}
                                            className="form-control f-regular mt-1"
                                            disabled={isTransfering}
                                            required
                                        ></textarea>
                                    </div>
                                </div>
                            ) : (
                                <div className="col-12 card mb-0">
                                    <div className="card-body row pos-blank-card">
                                        <p className="text-muted text-center w-100 my-4">
                                            No items scanned yet. Use the search
                                            bar above to scan a product.
                                        </p>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </Modal.Body>

            <Modal.Footer>
                {transferType !== null && (
                    <button
                        className="btn btn-primary btn-trans"
                        onClick={handleSubmitTransfer}
                        disabled={
                            isTransfering ||
                            isScanning ||
                            transfer_item.length === 0
                        }
                    >
                        {isTransfering && (
                            <span
                                className="spinner-border spinner-border-sm mr-1"
                                role="status"
                                aria-hidden="true"
                            ></span>
                        )}
                        {transferType === 'in'
                            ? 'In Stock Transfer'
                            : 'Out Stock Transfer'}
                    </button>
                )}
            </Modal.Footer>

            {/* ITEM MODAL */}
            <ItemModal transferType={transferType} />
        </Modal>
        </>
    );
}

const mapStateToProps = (state) => ({
    stock_transfer: state.stock_transfer,
    show: state.stock_transfer.multi_stock_transfer_modal,
});

export default connect(mapStateToProps, {
    handleInputChange,
    submitStockTransfer,
    searchSubmit,
})(MultiTransferModal);
